<script type="text/ecmascript-6">
    import DesignerQuestionTechnicalDrainage from "../DesignerQuestionTechnicalDrainage.vue";
    import SynsealQuestion from "../mixin/synseal/Question.vue";

    export default {
        mixins: [
            DesignerQuestionTechnicalDrainage,
            SynsealQuestion
        ],
    }
</script>
